/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
  MessageHeader, Message,
  ListItem,
  ListHeader,
  ListDescription,
  ListContent,
} from "semantic-ui-react";

import Abstract from "./Abstract.js";
// import Results from "./Results.js";
// import Comparison from "./Comparison.js";
// import Results from "./Results.js";

// import MyCarousel from "./Carousel.js";
// import Video from './Video.js';
import YouTube from './YouTube.js';
// import overview from "./images/framework-crop-1.jpg";
// import teaser from './images/teaser.png';
// import video_website from "./video/video-website.mp4";

import subsection_style from "./style.js";
// import MyCarousel from "./Carousel.js";
// import fig_noisy from './images/fig_noisy.jpg'
import './App.css'
// import overview from './images/overview.jpg'
import method from './images/method.jpg'
import result from './images/result.jpg'
import video_results from './images/results.mp4'

import LazyVideo from "./lazy-video";


const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

/* Heads up!
 * HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled
 * components for such things.
 */
const HomepageHeading = ({ mobile }) => (
  <Container fluid>
    {/* <Header
      as="h1"
      content="SinNeRF"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "2em" : "4em",
        fontWeight: "normal",
        marginBottom: 0,
        marginTop: mobile ? "0.5em" : "1em",
      }}
    /> */}
    <Header
      as="h1"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "1.5em" : "1.7em",
        fontWeight: "normal",
        marginTop: mobile ? "0.5em" : "1em",
      }}
    >
      <div>
      CamCo: Camera-Controllable 3D-Consistent
Image-to-Video Generation
      </div>
    </Header>
  </Container>
);

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
};

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Media greaterThan="mobile">
        <HomepageHeading />
        {children}
      </Media>
    );
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
};

class MobileContainer extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Media as={Sidebar.Pushable} at="mobile">
        <HomepageHeading mobile />

        {children}
      </Media>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
};

const ResponsiveContainer = ({ children }) => (
  /* Heads up!
   * For large applications it may not be best option to put all page into these containers at
   * they will be rendered twice for SSR.
   */
  <MediaContextProvider>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </MediaContextProvider>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

const Authors = () => (      <Container text>
  {/* <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
  </Grid> */}
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}
    <a href="https://ir1d.github.io/" target="_blank" rel="noreferrer">
      Dejia Xu<sup>1</sup>
    </a>
    <a href="https://weilinie.github.io/" target="_blank" rel="noreferrer">
      Weili Nie<sup>2</sup>
    </a>
    <a href="https://research.nvidia.com/person/chao-liu" target="_blank" rel="noreferrer">
      Chao Liu<sup>2</sup>
    </a>
    </Grid><Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
    <a href="https://sifeiliu.net/" target="_blank" rel="noreferrer">
      Sifei Liu<sup>2</sup>
    </a>
    <a href="https://jankautz.com/" target="_blank" rel="noreferrer">
      Jan Kautz<sup>2</sup>
    </a>
    <a
      href="https://express.adobe.com/page/CAdrFMJ9QeI2y/"
      target="_blank"
      rel="noreferrer"
    >
      Zhangyang Wang<sup>1</sup>
    </a>
    <a href="http://latentspace.cc/" target="_blank" rel="noreferrer">
      Arash Vahdat<sup>2</sup>
    </a>
    {/* </Grid.Column> */}
    {/* </Grid.Row> */}
  </Grid>
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
    <div>
      <sup>1</sup>University of Texas at Austin, <sup>2</sup>NVIDIA<br />
    </div>
  {/* </Grid>
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  > */}
    {/* <br /> */}
    {/* <div>*denotes equal contribution</div> */}
  </Grid>
  <Grid
        container
        stackable
        verticalAlign="middle"
        columns={2}
        width={10}
        textAlign="center"
        style={{
          fontSize: "1.2em",
          fontWeight: "normal",
          marginTop: "0.5em",
          marginBottom: "0.5em",
        }}
      >
        <Grid.Row>
          <Grid.Column columns={2}>
            <Button primary icon style={{backgroundColor: "#76B900"}}>
              <a
                href="https://arxiv.org/abs/2406.02509"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="book" />
                {" Paper"}
              </a>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
</Container>
)

const HomepageLayout = ({ mobile }) => (
  <ResponsiveContainer>
    <div>
      <Authors />

      <Container text style={{textAlign: "justify",}}>
      {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Overview
        </Header> */}
        {/* <MyCarousel mobile={mobile} ></MyCarousel> */}
        <p>
        <b>TL;DR:</b> We present a novel camera-controllable image-to-video generation framework, <b>CamCo</b>, that generates 3D-consistent videos. We introduce camera information via Plücker coordinates and propose epipolar constraint attention. We further fine-tune CamCo on real-world videos with camera poses estimated through structure-from-motion algorithms to better synthesize object motion.
        </p>
        {/* <figure> */}
        
        <LazyVideo src={video_results} no_control></LazyVideo>
        {/* <div textAlign="center"> */}
          <p textAlign="center">
            <small>
            <i textAlign="center">
            {/* We provide more generated videos and reconstructed 3D scenes in the following video. */}
            The reference videos are provided to visualize camera trajectory or input frame. 
            </i>
            </small>
          </p>
          <br></br>
        {/* </div> */}
        {/* <figcaption>Caption goes here</figcaption>
        </figure> */}
        {/* <br></br> */}
        {/* <Comparison /> */}
        {/* <Results /> */}
        
        <Abstract mobile={mobile} />
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Visualizations
        </Header> */}
        {/* <MyCarousel mobile={mobile} /> */}
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Video (narrated)
        </Header> */}
        <br></br>
        {/* <YouTube src={`https://www.youtube.com/embed/XJT-cMt_xVo?rel=0&amp;autoplay=p1&mute=1`}></YouTube> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
        Method
        </Header>
        <p>
        We propose CamCo, a novel camera-controllable image-to-video generation framework that can generate high-quality, 3D-consistent videos. CamCo relies on Plucker embeddings and epipolar constraint attention blocks to inject camera parameters into the model. We also introduce a data curation pipeline to handle in-the-wild videos with dynamic subjects and fine-tune CamCo on the curated dataset to enhance its ability to generate videos with both camera ego-motion and dynamic subjects.
        </p>
        <Image src={method} style={subsection_style} centered="true" ></Image>
        <List>
          <ListItem as='a'>
            <Icon name='right triangle' />
            <ListContent>
              {/* <ListHeader>(a)</ListHeader> */}
              <ListDescription>
                (a) Shows our architecture, where we introduce Plücker coordinates as an effective camera parameterization and an epipolar constraint attention block to enforce geometry consistency.
              </ListDescription>
            </ListContent>
          </ListItem>
          <ListItem as='a'>
            <Icon name='right triangle' />
            <ListContent>
              {/* <ListHeader>(a)</ListHeader> */}
              <ListDescription>
                (b) Illustrates our epipolar constraint attention block. Through epipolar lines, features from the first frame are associated with features from the rest of the frames.
              </ListDescription>
            </ListContent>
          </ListItem>
        </List>
        <Header as="h2" textAlign="center" style={subsection_style}>
        Results
        </Header>
        
        {/* <br></br> */}

        <p>
        Given a single frame (the first image column) and a sequence of cameras as input, CamCo model can synthesize videos that follow the camera conditions with 3D consistency.
We support indoor, outdoor, object-centric, and text-to-image generated images. The prompt for the last row is "A lush garden filled with blooming roses of various colors, with a gravel path winding through it". The camera of the first frame is shown in purple.
        </p>
        <Image src={result} style={subsection_style}></Image>
        {/* <YouTube src={`https://www.youtube.com/embed/sg7uUUfpM-c?rel=0&amp;autoplay=p1&mute=1`}></YouTube> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
          Citation
        </Header>
        <p style={{ paddingBottom: "0.5em", overflow: "auto" }}>
          If you want to cite our work, please kindly use:
          <pre>
            <code>
              {`@article{xu2024camco,
  title={CamCo: Camera-Controllable 3D-Consistent Image-to-Video Generation},
  author={Xu, Dejia and Nie, Weili and Liu, Chao and Liu, Sifei and Kautz, Jan and Wang, Zhangyang and Vahdat, Arash},
  journal={arXiv preprint arXiv:2406.02509},
  year={2024}
}\}`}
            </code>
          </pre>
        </p>
        <br></br>
      </Container>
    </div>
  </ResponsiveContainer>
);

export default HomepageLayout;
